import { Component, Input} from '@angular/core';

@Component({
  standalone: false,
    selector: 'faro-hitlist-table',
    templateUrl: './hitlist-table.component.html',
    styleUrls: ['./hitlist-table.component.scss'],
})
export class HitlistTableComponent {
    @Input()
    rowActionsDelay: number = 0;

    @Input()
    tableHeaders: string[] = [];

    @Input()
    tableData: any[] = [];

    @Input()
    hasTooltip: boolean = false;

    timeOut: any;
    currentIndex: number | undefined;
    isTooltip = false;
    searching = false;

    showRowActions(index: number) {
        this.timeOut = setTimeout(() => {
            this.currentIndex = index;
        }, this.rowActionsDelay);
    }

    hideRowActions(): void {
        clearTimeout(this.timeOut);
        this.currentIndex = undefined;
    }

    goToDetails(hit: any) {
        console.log('TODO: go to details');
    }

    addToShoppingCart(hit: any) {
        console.log('TODO: add to cart');
    }

    showTooltip(): boolean {
        if (this.hasTooltip) {
            this.isTooltip = true;
            return this.isTooltip;
        } else {
            return false;
        }
    }

    hideTooltip(): boolean {
        this.isTooltip = false;
        return this.isTooltip;
    }
}
